import {Flex, Stack, useTheme} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React, {useEffect} from 'react'
import AddToCartCTA from '../../../components/add-to-cart-cta'
import useMultiSite from '../../../hooks/use-multi-site'
import {useKindlyChat} from '../../../components/kindly-chat'
import ProductDisplayPrice from '../../../components/product-display-price'
import useBreakpoints from '../../../hooks/use-breakpoints'

const PdpCta = ({
    product,
    isPromotionsLoading,
    isVariantLoading,
    promotions,
    quantity,
    ...props
}) => {
    const theme = useTheme()
    const {site} = useMultiSite()

    // move kindly on mobile view to not overlap with the cta
    const kindlyOffset = useBreakpoints(
        // matches the display and height with some margin of the cta
        {base: '5rem', lg: 0}
    )
    const kindlyApi = useKindlyChat()
    useEffect(() => {
        kindlyApi?.setBottomOffset(kindlyOffset)
    }, [kindlyApi, kindlyOffset])

    return (
        <Flex
            display={{base: 'flex', lg: 'none'}}
            position="fixed"
            left={0}
            bottom={0}
            width="100%"
            zIndex="sticky"
            align="center"
            height={16.5}
            gap={4}
            background="stokkeCore.white"
            boxShadow={theme.shadows.top}
        >
            {!site?.isContentOnlySite && (
                <Stack spacing={0} paddingLeft={4} minW="0" flex="1">
                    <ProductDisplayPrice
                        product={product}
                        loading={isPromotionsLoading || isVariantLoading}
                        variant="stickyCta"
                    />
                </Stack>
            )}
            <Flex
                paddingRight={2}
                minW="0"
                flex="1"
                justifyContent="center"
                alignItems="center"
                gap={2.5}
            >
                <AddToCartCTA
                    isLoading={isPromotionsLoading || isVariantLoading}
                    product={product}
                    quantity={quantity}
                    variant="solidGreen"
                    {...props}
                />
            </Flex>
        </Flex>
    )
}

PdpCta.propTypes = {
    product: PropTypes.object,
    promotions: PropTypes.array,
    quantity: PropTypes.number,
    isPromotionsLoading: PropTypes.bool,
    isVariantLoading: PropTypes.bool
}

export default PdpCta
